const Loading=()=>{
return (
    <div className="loading_container">
         <div className="loading"></div>
    </div>
   
)
}

export default Loading;